import { APIFieldAttributes, Metamodel } from '@ardoq/api-types';
import {
  getMetamodelComponentCompletion,
  getMetamodelReferenceCompletion,
  metamodelIsEmpty,
} from './utils';
import { MetamodelSubtitle } from './atoms';
import { BreadCrumbNavigation } from './breadCrumbNavigation/BreadCrumbNavigation';
import { ComponentFieldCompletionWidget } from './completion/ComponentFieldCompletionWidget';
import { ReferenceFieldCompletionWidget } from './completion/ReferenceFieldCompletionWidget';
import { WorkspaceNavigationTitle } from './workspaceNavigationTitle/WorkspaceNavigationTitle';
import { MetamodelContext } from 'metamodel/types';
import { DefaultNotification } from '@ardoq/status-ui';
import { Box } from '@ardoq/layout';
import { t, type I18nLocale } from '@ardoq/i18n';

const MetamodelStats = ({
  metamodel,
  context,
  nonTemplateFieldsByName,
  i18nLocale,
}: {
  metamodel: Metamodel;
  context: MetamodelContext;
  nonTemplateFieldsByName: Map<string, APIFieldAttributes>;
  i18nLocale: I18nLocale;
}) => {
  const content = metamodel.metamodel;

  const componentCompletion = getMetamodelComponentCompletion(content);
  const referenceCompletion = getMetamodelReferenceCompletion(content);

  return (
    <Box position="relative">
      <BreadCrumbNavigation
        metamodel={metamodel}
        nonTemplateFieldsByName={nonTemplateFieldsByName}
      />
      <Box marginTop="small">
        <WorkspaceNavigationTitle
          metamodel={metamodel}
          context={context}
          i18nLocale={i18nLocale}
        >
          {metamodel.name}
        </WorkspaceNavigationTitle>
      </Box>
      <MetamodelSubtitle
        componentCompletion={componentCompletion}
        referenceCompletion={referenceCompletion}
        i18nLocale={i18nLocale}
      />
      {metamodelIsEmpty(content) ? (
        <DefaultNotification>
          {t(
            i18nLocale,
            'metamodel:stats.metamodel.emptyAll',
            'The workspaces in this Metamodel have no components or references'
          )}
        </DefaultNotification>
      ) : (
        <>
          <ComponentFieldCompletionWidget
            componentTypeFieldCompletion={componentCompletion}
            content={content}
            context={context}
            notification={t(
              i18nLocale,
              'metamodel:stats.metamodel.emptyComponents',
              'The workspaces in this Metamodel have no components'
            )}
            i18nLocale={i18nLocale}
          />
          <ReferenceFieldCompletionWidget
            referenceTypeFieldCompletion={referenceCompletion}
            content={content}
            context={context}
            notification={t(
              i18nLocale,
              'metamodel:stats.metamodel.emptyReferences',
              'The workspaces in this Metamodel have no references'
            )}
            i18nLocale={i18nLocale}
          />
        </>
      )}
    </Box>
  );
};

export { MetamodelStats };
